"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MISSING_PLACEMENT_MESSAGE = void 0;
exports.addToBasket = addToBasket;
var AddToBasketFailed = _interopRequireWildcard(require("@ori-events/add-to-basket-failed"));
var ShowLoyaltyDialog = _interopRequireWildcard(require("@ori-events/show-loyalty-dialog"));
var _checkoutUtils = require("@ori/checkout-utils");
var _logger = require("../logger");
var _convertToCamelCase = require("./convertToCamelCase");
var _getHttpRequestSettings = require("./getHttpRequestSettings");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const MISSING_PLACEMENT_MESSAGE = exports.MISSING_PLACEMENT_MESSAGE = `Missing 'placement' property in add-to-basket action data will impact reporting, please contact your SE.`;
async function addToBasket(url, params, buyingMethod) {
  const {
    itemCode,
    placement,
    quantity
  } = params;
  if (placement === undefined) {
    (0, _logger.logWarning)(MISSING_PLACEMENT_MESSAGE);
  }
  const response = await fetch(url, (0, _getHttpRequestSettings.getHttpRequestSettings)(params, _checkoutUtils.HttpMethod.Post));
  const data = (0, _convertToCamelCase.convertToCamelCase)(await response.json());
  if (AddToBasketFailed.isAddToBasketErrorResponse(data)) {
    const event = new CustomEvent(AddToBasketFailed.Name, {
      detail: data
    });
    window.dispatchEvent(event);
    return false;
  }
  if (AddToBasketFailed.isAddToBasketLoyaltyResponse(data)) {
    const event = new CustomEvent(ShowLoyaltyDialog.Name, {
      detail: {
        ...data,
        itemCode,
        placement,
        quantity
      }
    });
    window.dispatchEvent(event);
    return false;
  }
  return {
    ...data,
    lastAddedItem: {
      itemCode,
      method: buyingMethod,
      quantity
    }
  };
}
//# sourceMappingURL=addToBasket.js.map